import { render, staticRenderFns } from "./registrationType.vue?vue&type=template&id=3637c644"
import script from "./registrationType.vue?vue&type=script&lang=js"
export * from "./registrationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports